var _ = require('underscore');
// Javascript internationalization namespace
module.exports = {
  // Public: Set the translations that could be used in client-side code
  //
  // Translations are added through the #require_client_side_translations
  // helper in a server-side template.
  //
  // translations - Object mapping String keys to String translations.
  //
  // Returns nothing.
  setTranslations: function(translations) {
    this._translations = translations;
  },

  // Public: Retrieve a string from the hash, and/or perform substitutions.
  //
  // keyOrString   - String translation key or actual string to display.
  // substitutions - Object of data to use for substitutions (default: none).
  //
  // Returns string;
  t: function(keyOrString, substitutions) {
    var str = null;

    if (!_.isUndefined(this._translations)) {
      str = this._translations[keyOrString];
    }

    if (!str) str = keyOrString;

    substitutions = substitutions || {};
    var str = str.replace(/%\{(.+?)\}/g, function() {
      return substitutions[arguments[1]] || "";
    });

    return str;
  },

  // Test-only: Retrieve dictionary of localized strings
  //
  // Not intended to be used anywhere other than tests
  // .t method is the only valid way to retrieve localized strings
  //
  // Returns Hash
  getTranslations: function() {
    return this._translations;
  }
};
